import EditableField from 'src/components/fields/EditableField/EditableField';

export default EditableField;
